import { render, staticRenderFns } from "./ModalAjudaSitAtestado.vue?vue&type=template&id=50c66921&"
import script from "./ModalAjudaSitAtestado.vue?vue&type=script&lang=js&"
export * from "./ModalAjudaSitAtestado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports